import { render, staticRenderFns } from "./search-tree.vue?vue&type=template&id=62948f40&scoped=true"
import script from "./search-tree.vue?vue&type=script&lang=js"
export * from "./search-tree.vue?vue&type=script&lang=js"
import style0 from "./search-tree.vue?vue&type=style&index=0&id=62948f40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62948f40",
  null
  
)

export default component.exports